// below we dynamically set the webpack public path at runtime
// documentation: http://webpack.github.io/docs/configuration.html#output-publicpath

__webpack_public_path__ = window.location.protocol + "//" + window.location.host + "/"
